import React from "react";
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';

const confirmBodyCss = css`
    margin-bottom: 30px; 
    max-width: 800px;
    .type {
        font-size: 16px; 
        font-weight: 600;
    }
    .item-text {
        margin-left: 15px;
    }
    .val {
        font-weight: 600;
    }
`;

const ConfirmBasicInfo = ({ arr, val }) => (
    <>
    {arr?.map((x, i) => (
        <div css={confirmBodyCss} key={x.type + i}>
            <>
                {x.type === 'adding a new journal' && (
                <>
                    <p className="type">{i + 1}. You are {x.type}.</p>
                    <div className="item-text">The category is</div>
                    <p className="item-text val">"{val.category}"</p>
                    <div className="item-text">and the prompt is</div>
                    <p className="item-text val">"{val.prompt}"</p>
                </>
                )}
                {x.type !== 'adding a new journal' && (
                <>
                    <p className="type">{i + 1}. You are {x.type}</p>
                    {x.initCopy ? (
                    <>
                        <p className="item-text">From: <span className="val">"{x.initCopy}"</span></p>
                        <p className="item-text">To: <span className="val">"{x.type === 'editing a prompt' ? val.prompt : val.category}"</span></p>
                    </>)
                    : (<p className="item-text"><span className="val">"{x.type === 'editing a prompt' ? val.prompt : val.category}"</span></p>)}
                </>
                )}
            </>
        </div>
    ))}
    </>
);

const ConfirmInternational = ({ arr }) => (
    <>
    {arr?.map((x, i) => (
        <div css={confirmBodyCss} key={x.type + i}>
            <>
                <p className="type">{i + 1}. You are {x.type}</p>
                {x.type === 'adding a new journal' && (
                <>
                    <p className="item-text">The international setting is <span className="val">"{x.international ? 'On' : 'Off'}"</span></p>
                    <p className="item-text">The journal is <span className="val">"{x.global ? 'On' : 'Off'}"
                        </span> globally and <span className="val">"{x.global ? 'hidden from' : 'visible to'}"</span> these countries:
                    </p>
                    <p className="item-text val">"{x.countries}"</p>
                </>
                )}
                {x.type !== 'adding a new journal' && (
                <>
                    <p className="item-text">From: <span className="val">"{x.prev}"</span></p>
                    <p className="item-text">To: <span className="val">"{x.current}"</span></p>
                </>
                )}
            </>
        </div>
    ))}
    </>
);

const ConfirmCobrands = ({ arr }) => (
    <>
    {arr?.map((x, i) => (
        <div css={confirmBodyCss} key={x.type + i}>
            <>
                <p className="type">{i + 1}. You are {x.type}</p>
                {x.type === 'adding a new journal' && (
                <>
                    <p className="item-text">The journal is <span className="val">"{x.allCobrands ? 'On' : 'Off'}"
                        </span> for all cobrands and <span className="val">"{x.allCobrands ? 'hidden from' : 'visible to'}"</span> these cobrands:
                    </p>
                    <p className="item-text val">"{x.cobrands}"</p>
                </>
                )}
                {x.type !== 'adding a new journal' && (
                <>
                    <p className="item-text">From: <span className="val">"{x.prev}"</span></p>
                    <p className="item-text">To: <span className="val">"{x.current}"</span></p>
                </>
                )}
            </>
        </div>
    ))}
    </>
);

export {
    ConfirmBasicInfo,
    ConfirmInternational,
    ConfirmCobrands,
}